<template>
  <b-form-file ref="fileInput" v-model="file" @input="fileChanged" accept="application/pdf"/>
</template>

<script>
import Attributes from "../../models/Attributes";
import normalize from "json-api-normalize";

export default {
  props: ['uploader'],

  data: function () {
    return {
      file: null
    }
  },

  methods: {
    fileChanged: function (file) {
      this.$emit('uploading', file, this.uploader)
      const formData = new FormData();
      formData.append('release_form[release_type]', this.uploader.releaseType);
      formData.append('release_form[data]', file);

      this.$http.post(this.uploader.url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(fulfilled => {
        this.$emit('complete', normalize(fulfilled.body).get(Attributes.releaseFormAttributes), this.uploader)
      }, rejected => {
        this.$emit('error', rejected, this.uploader);
      })
    },
  },

  mounted: function () {
    this.$refs.fileInput.$el.childNodes[0].click();
  }
}
</script>